import React from 'react';
import { Grid, Card } from "@mui/material";
import { texts } from '../../general/texts';
import colors from '../../colors';
import ButtonGroup from '../../general/ButtonGroup';
import EventsAndPartners from './EventsAndPartners';
import { Button } from '@mui/base';
import UanatacaDialog from '../../general/uanataca/Uanataca';

const EventsOverview = () => {
  const [state, setState] = React.useState({})

  const searchMethods = [
    { display: texts["title-events"], value:'1'},
    { display: texts["prompt-partner"], value:'2'}
]

  const getSearchMethodValue = (value) => 
  {
      setState({...state, selectedSearchMethod: value})
  }

  const selectedButtonStyle =
  {
      backgroundColor: colors.lightOrange,
      color: colors.orange,
      width:'150px',
      height:'40px',
      fontFamily:'GerberaBold',
      textTransform:'none',
      fontSize:'1rem',
      border: '2px solid'+colors.orange,
      borderRadius:'10px',
      '&:hover': {
          backgroundColor: colors.lightOrange
      },
      '@media (max-width: 899px)' : {width:'130px', height:'40px'}                 
  }

  const defaultButtonStyle =
  {
      backgroundColor: colors.lightBlue,
      width:'150px',
      height:'40px',
      borderRadius:'10px',
      textTransform:'none',
      fontFamily:'GerberaLight',
      fontSize:'1rem',
      color: colors.darkBlue,
      '&:hover': {
          backgroundColor: colors.lightOrange
      },
      '@media (max-width: 899px)' : {width:'130px', height:'40px'}      
  }

  return (
    <Grid container item md={12} xs={12} justifyContent={"center"} pt={"2%"}>
      <Card
        sx={{
          borderRadius: "20px",
          boxShadow: "0 0 15px 5px #E5E7EA",
          padding: "2%",
          background: colors.white,
          width: "54%",
          minHeight: "65vh",
          "@media (max-width: 899px)": { width: "80%" },
        }}
      >
          <Grid
            container
            item
            md={12}
            xs={12}
            columnSpacing={0.5}
            justifyContent={"space-between"}
            rowSpacing={2}
            mb={1.5}
          >
              <Grid container item md={12} xs={12} justifyContent='center' columnSpacing={5} rowSpacing={3} mb={4}>
                      <ButtonGroup defaultButtonStyle={defaultButtonStyle} selectedButtonStyle={selectedButtonStyle} state={searchMethods} sendValue={getSearchMethodValue} />
              </Grid>
              {state.selectedSearchMethod === '1' &&
                 <EventsAndPartners isEvent={true} />
              }
              {state.selectedSearchMethod === '2' &&
                <EventsAndPartners isEvent={false} />
              }
            </Grid>
      </Card>
    </Grid>
  );
}

export default EventsOverview;